export const bonus_revive_dialog = {
	BONUS_REVIVE_DIALOG_HEADER: {
		value: 'BONUS REVIVE',
		config: {
			fontName: 'custom_font',
			fontSize: 28,
			letterSpacing: 5
		}
	},
	BONUS_REVIVE_DIALOG_TITLE_0: {
		value: 'DO YOU WANT TO CONTINUE PLAYING',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_REVIVE_DIALOG_TITLE_1: {
		value: 'WHERE YOU HAVE BEEN STOPPED?',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_REVIVE_DIALOG_DESCRIPTION_0: {
		value: 'YOU WILL GET',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_REVIVE_DIALOG_FREESPIN: {
		value: '0',
		config: {
			fontName: 'custom_font',
			fontSize: 36
		}
	},
	BONUS_REVIVE_DIALOG_DESCRIPTION_1: {
		value: 'FREESPINS',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_REVIVE_DIALOG_DESCRIPTION_2: {
		value: 'AT COST OF',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_REVIVE_DIALOG_FREESPIN_COST: {
		value: '$200',
		config: {
			fontName: 'custom_font',
			fontSize: 36,
			letterSpacing: 5
		}
	},
	BONUS_REVIVE_DIALOG_YES_BTN: {
		value: 'YES',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	BONUS_REVIVE_DIALOG_NO_BTN: {
		value: 'NO',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	}
};
